import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { Injectable } from '@angular/core';
import { LoadingService } from 'proleis-web-app';
import { HandleAuthErrorServiceService } from './handle.auth.error.service.service';
import { UrlSegment } from '@angular/router';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorService: NotificationService,
    private ls: LoadingService,
    private authErrorService: HandleAuthErrorServiceService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next
      .handle(req)
      .pipe(catchError((err) => this.handleError(req, next, err)));
  }

  handleError(
    req: HttpRequest<any>,
    next: HttpHandler,
    err: HttpErrorResponse,
  ) {
    this.ls.setLoading(false, req.url);
    if (err.status === 401 || err.status === 403) {
      this.authErrorService.handleAuthError([
        new UrlSegment(window.location.pathname, undefined),
      ]);
    } else {
      this.errorService.showError(err);
    }
    return next.handle(req);
  }
}
